export default "__VITE_ASSET__89f5606e__"